import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatInputModule } from "@angular/material/input";

@Component({
    selector: "eff-input",
    templateUrl: "./eff-input.component.html",
    styleUrls: ["./eff-input.component.scss"],
    imports: [CommonModule, ReactiveFormsModule, MatInputModule]
})
export class EffInputComponent implements OnInit, OnChanges {
    @Input() model;
    @Input() type: string;
    @Input() label: string;
    @Input() formController: FormControl;
    @Input() disabled: boolean = false;
    /** An error to show on top of the form control's own errors. The caller translates it. */
    @Input() errorMessage: string;
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.disableEnableFormControl();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["disabled"]) {
            this.disableEnableFormControl();
        }
    }

    disableEnableFormControl() {
        if (this.formController) {
            if (this.disabled) {
                this.formController.disable();
            } else {
                this.formController.enable();
            }
        }
    }

    onModelChanged() {
        this.modelChange.emit(this.model);
    }

    hasErrors() {
        if (this.errorMessage) {
            return true;
        }
        if (this.formController) {
            return this.formController.errors != null || this.formController.errors != undefined;
        }
        return false;
    }
}
